//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, MMinus, T } from "../../utils/MT";

export default function ProductInfo(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate.push(`/product/detail/:` + props.i);
    };

    return (
        // 구매자 정보
        <>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>구매자정보</MyPageTitle>
            </MyPageTitleBox>

            <UserInfoBoxWrap>
                <thead>
                    <tr>
                        <InfoTitle>주문자</InfoTitle>
                        <InfoContent>최신도</InfoContent>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <InfoTitle>이메일주소</InfoTitle>
                        <InfoContent>sindoh@naver.com</InfoContent>
                    </tr>
                    <tr>
                        <InfoTitle>전화번호</InfoTitle>
                        <InfoContent></InfoContent>
                    </tr>
                    <tr>
                        <InfoTitle>휴대폰번호</InfoTitle>
                        <InfoContent>010-1234-5678</InfoContent>
                    </tr>
                </tbody>
            </UserInfoBoxWrap>
        </>
    );
}

const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
// 구매자정보
const UserInfoBoxWrap = styled.table`
    width: 100%;
    min-height: calc(100vw * (240 / 1920));
    margin-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #222222;
    border-bottom: 1px solid #dddddd;

    & tr {
        border-bottom: 1px solid #dddddd;
    }

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (240 / 1300));
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        min-height: ${M(180)};
        margin-top: ${M(20)};
    }
`;
const InfoTitle = styled.th`
    flex-shrink: 0;
    width: calc(100vw * (180 / 1920));
    padding: calc(100vw * (21 / 1920)) 0;
    font-size: calc(100vw * (15 / 1920));

    border-right: 1px solid #dddddd;
    text-align: center;
    background: #fafafa;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));
        padding: calc(100vw * (21 / 1300)) 0;
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(120)};
        padding: ${M(13)} 0;
        font-size: ${M(14)};
    }
`;
const InfoContent = styled.td`
    flex-shrink: 0;
    width: calc(100% - 100vw * (180 / 1920));

    padding: calc(100vw * (20 / 1920)) calc(100vw * (40 / 1920));
    font-size: calc(100vw * (15 / 1920));
    word-break: break-all;

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (180 / 1300));
        padding: calc(100vw * (20 / 1300)) calc(100vw * (40 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${MMinus(120)};
        padding: ${M(13)} ${M(15)};
        font-size: ${M(14)};
    }
`;
